import { render } from "./FrameDesktopComponent.vue?vue&type=template&id=3c273d5e&scoped=true"
import script from "./FrameDesktopComponent.vue?vue&type=script&lang=js"
export * from "./FrameDesktopComponent.vue?vue&type=script&lang=js"

import "./FrameDesktopComponent.vue?vue&type=style&index=0&id=3c273d5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c273d5e"]])

export default __exports__